import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getWebTreePlan = (payload) => httpClient.get(apis.getWebTreePlan(payload));
